import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "content", "save", "filters", "header", "subheader", "squad", "8888", "9999"]

  connect() {
    this.controllerName = `users--works--trackers--projects--show`
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.cardLoader = this.getControllerByIdentifier("app--helpers--loaders").cardLoader()
    this.bodyCardLoader = this.getControllerByIdentifier("app--helpers--loaders").bodyCardLoader()
    this.application.permissions = {}
    // this.application.project = {}
    this.application.team = []
    this.application.precedents = []
    this.application.notes = []
    this.application.current_squad = {}
    this.application.project_token = location.pathname.split("/").pop()
    this.sort = `started_at_to_time`
    this.hasFilter = false
    this.filter = ``
    this.projectsDashboard()
  }

  setHeaderPage() {
    this.getControllerByIdentifier("app--navigation--desktop--breadcrumb").breadcrumbNameTarget.innerText = `Projeto ${this.application.project.name}`
    this.headerTarget.innerText = `Projeto ${this.application.project.name}`
    this.subheaderTarget.innerText = `Crie os entregáveis e acompanhe as atividades.`
  }

  projectsDashboard() {
    const html = `<div class="row my-2">
                    <div class="col-2 px-2">
                      <div class="row my-2" data-controller="users--works--trackers--squads--show">
                        <div class="col-12">
                          <h6 class="mb-0 text-center d-flex" data-users--works--trackers--squads--show-target="title">${this.loader}</h6>
                          <hr class="mt-1">
                          <div class="row my-2" data-users--works--trackers--squads--show-target="main"></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 px-2">
                      <div class="row my-2" data-controller="users--works--trackers--stories--index users--works--trackers--stories--save">
                        <div class="col-12 px-0">
                          <h6 class="mb-0 text-center d-flex mx-auto" data-users--works--trackers--stories--index-target="title">${this.loader}</h6>
                          <hr class="mt-1">
                          <div class="row my-2" data-users--works--trackers--stories--index-target="main" data-users--works--trackers--stories--save-target="form"></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 px-2">
                      <div class="row my-2" data-controller="users--works--trackers--projects--notes">
                        <div class="col-12 px -2">
                          <h6 class="mb-0 text-center d-flex" data-users--works--trackers--projects--notes-target="title">${this.loader}</h6>
                          <hr class="mt-1">
                          <div class="row my-2" data-users--works--trackers--projects--notes-target="main"></div>
                        </div>
                      </div>
                    </div>
                  </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      // controller.projectsPreloader()
      controller.getCurrentUserPermissions()
    })
  }

  setCurrentSquad() {
    this.application.project.squads.forEach(element => {
      if (element.team_id == this.application.current_user.account_id) {
        this.application.current_squad = element
      }
    })
  }

  finishLoadPage() {
    this.setCurrentSquad()
    this.setHeaderPage()
    this.getControllerByIdentifier(`users--works--trackers--stories--index`).doStoriesHeader()
    this.getControllerByIdentifier(`users--works--trackers--stories--index`).doStoriesHtml()
    this.getControllerByIdentifier(`users--works--trackers--stories--index`).doFiltersHtml()
    this.getControllerByIdentifier(`users--works--trackers--squads--show`).doSquadsHeader()
    this.getControllerByIdentifier(`users--works--trackers--squads--show`).doSquadsHtml()
    this.getControllerByIdentifier(`users--works--trackers--projects--notes`).doNotesHeader()
    this.getControllerByIdentifier(`users--works--trackers--projects--notes`).setNotes()


    var response = { type: `success`, message: `Página carregada com sucesso!` }
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).closeLoadModal()
    this.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
  }

  getNotes() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Anotações`, value: 70 })

    var data = { note: { domain_id: this.application.project.id, domain_type: `tracker_projects` }, current_user: { current_user_id: this.application.current_user.id, feature: `user_works_trackers_notes` } }
    const url = "/users/accounts/notes/list_by_domain"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.notes = response.data.cln

        controller.finishLoadPage()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getPrecedents() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Relações`, value: 60 })

    var data = { story: { project_id: this.application.project.id }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/users/works/trackers/stories/list_names"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.precedents = response.data.cln

        controller.getNotes()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getTeam() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Time`, value: 50 })

    const url = "/users/works/trackers/teams/list"
    const data = { user: { account_kind: "team" }, current_user: { current_user_id: this.application.current_user.id } }
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.team = response.data.cln
        controller.application.team_list = response.data.cln

        controller.getPrecedents()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getProject() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Projeto`, value: 30 })

    var data = { project: { id: this.application.project_token }, current_user: { current_user_id: this.application.current_user.id, feature: `user_works_trackers_projects` } }
    const url = "/users/works/trackers/projects/read"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.project = response.data.cln

        controller.getTeam()

      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getCurrentUserPermissions() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).openLoadModal({ submessage: `Carregando Permissões` })

    const data = { permissions: { subdomain: `work_trackers` }, current_user: { current_user_id: this.application.current_user.id, feature: `user_works_trackers_permissions`, account_kind: this.application.current_user.account_kind } }
    const url = "/users/permissions/policies/list_by_domain"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(permission => {
          controller.application.permissions[permission.name] = permission.data
        })

        controller.getProject()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(9, 6))
  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
